import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Sellers() {
  const [seller, setSeller] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_GATEWAY_END_POINT}/sellers`)
      .then((response) => {
        setSeller(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (seller !== null && seller !== '' && seller !== undefined) {
    if (seller.Json !== null && seller.Json !== '' && seller.Json !== undefined) {
      return window.location.replace(seller.Json.url);
    } else if (seller.Url !== '' && seller.Url !== null) {
      return window.location.replace(seller.Url);
    } else {
      return '';
    }

  } else {
    return '';
  }

}

export default Sellers;
